import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "../lib/api";
import { useSeo } from "../lib/useSeo";
import { htmlLangOf } from "../i18n";
import { PublicEventCard } from "../components/PublicEventCard";

export default function PublicEvents() {
  const { t, i18n } = useTranslation();
  const [upcoming, setUpcoming] = useState([]);
  const [past, setPast] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get("/public/events", { params: { scope: "upcoming" } }),
      api.get("/public/events", { params: { scope: "past" } }),
    ]).then(([a, b]) => { setUpcoming(a.data); setPast(b.data); })
      .catch(() => {}).finally(() => setLoading(false));
  }, []);

  useSeo({
    title: `${t("pub.upcomingTitle")} · VytaliDays`,
    description: t("pub.upcomingLead"),
    path: "/events",
    lang: htmlLangOf(i18n.language),
  });

  return (
    <div className="px-4 py-14 sm:px-6" data-testid="public-events-page">
      <div className="mx-auto max-w-6xl">
        <h1 className="font-display text-4xl font-extrabold sm:text-5xl">{t("pub.upcomingTitle")}</h1>
        <p className="mt-3 max-w-2xl text-base text-muted-foreground">{t("pub.upcomingLead")}</p>

        {loading && <p className="mt-10 text-sm text-muted-foreground">{t("common.loading")}</p>}

        {!loading && upcoming.length === 0 && (
          <p data-testid="public-events-empty"
            className="mt-10 rounded-2xl border border-border bg-card p-8 text-center text-sm font-semibold text-muted-foreground">
            {t("pub.noEvents")}
          </p>
        )}

        {upcoming.length > 0 && (
          <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {upcoming.map((e) => <PublicEventCard key={e.slug} event={e} />)}
          </div>
        )}

        {past.length > 0 && (
          <section className="mt-16">
            <h2 className="font-display text-2xl font-extrabold">{t("pub.pastEvents")}</h2>
            <div className="mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {past.map((e) => <PublicEventCard key={e.slug} event={e} />)}
            </div>
          </section>
        )}
      </div>
    </div>
  );
}
